import { render, staticRenderFns } from "./display-field-document.vue?vue&type=template&id=37482ecd&scoped=true&"
import script from "./display-field-document.ts?vue&type=script&lang=ts&"
export * from "./display-field-document.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-document.scss?vue&type=style&index=0&id=37482ecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37482ecd",
  null
  
)

export default component.exports